const styles = theme => ({
    button: {
      margin: 4,
    },
    input: {
      display: 'none',
    },
  });
export default styles


// WEBPACK FOOTER //
// ./src/components/UI/ButtonStyle.js